module.exports = __webpack_public_path__ + "img/banner.5bf0be7.png";